import { render, staticRenderFns } from "./MinisiteList.vue?vue&type=template&id=c828edd4&"
import script from "./MinisiteList.vue?vue&type=script&lang=js&"
export * from "./MinisiteList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c828edd4')) {
      api.createRecord('c828edd4', component.options)
    } else {
      api.reload('c828edd4', component.options)
    }
    module.hot.accept("./MinisiteList.vue?vue&type=template&id=c828edd4&", function () {
      api.rerender('c828edd4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/MinisiteList.vue"
export default component.exports